module.exports = __webpack_public_path__ + "static/media/accent_off.0bb16d96.svg";